import React from "react";
import { Input } from "@windmill/react-ui";

const InputArea = ({
  register,
  trigger,
  defaultValue,
  required,
  name,
  label,
  type,
  placeholder,
  pattern,
  minLength,
  maxLength,
  value,
  readOnly,
  onChange,
}) => {
  const validation = {
    required: required === false ? false : `${label} is required!`,
    pattern: {
      value: pattern,
      message: `Invalid ${label}!`,
    },
    maxLength: {
      value: maxLength,
      message: `Maximum Length ${maxLength} digits!`,
    },
    minLength: {
      value: minLength,
      message: `Minimum Length ${minLength} digits!`,
    },
    validate: (value) => {
      if (typeof value === "string" && value.trim() === "" && required !== false) {
        return `${label} is required!`;
      }
      return true;
    },
  };

  const handleInput = (event) => {
    const inputValue = event.target.value.toUpperCase();  // Convert input value to uppercase
    if (inputValue.length > maxLength) {
      event.target.value = inputValue.slice(0, maxLength);
      return;
    }
    event.target.value = inputValue; // Update the value with the uppercase string
  };

  return (
    <>
      <Input
        {...register(`${name}`, validation)}
        defaultValue={defaultValue}
        type={type}
        placeholder={placeholder}
        onInput={handleInput}  // Call handleInput for input events
        name={name}
        value={value}
        readOnly={readOnly}
        autoComplete="off"
        onChange={onChange}
        className="border h-12 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
      />
    </>
  );
};

export default InputArea;
